(function(){
  'use strict';
  var root=document.querySelector('[data-tjmn]');
  var drawer=document.querySelector('[data-tjmn-drawer]');
  if(!root||!drawer||root.dataset.initialized==='1')return;
  root.dataset.initialized='1';
  // A fixed header avoids inherited sticky/transform behavior from the legacy theme.
  // Preserve the initial document position with a measured spacer.
  var spacer=document.createElement('div');
  spacer.className='tjmn-page-spacer';
  spacer.setAttribute('aria-hidden','true');
  root.parentNode.insertBefore(spacer,root.nextSibling);
  var initialHeaderHeight=0;
  function measureHeader(){
    if(!window.matchMedia('(max-width:749px)').matches){
      spacer.style.height='0px';
      return;
    }
    if(!root.classList.contains('is-compact')){
      initialHeaderHeight=root.getBoundingClientRect().height||initialHeaderHeight;
    }
    spacer.style.height=Math.ceil(initialHeaderHeight)+'px';
  }
  var compactEnabled=root.dataset.compactEnabled!=='false';
  var compactThreshold=Number(root.dataset.compactThreshold||90);
  var opener=root.querySelector('[data-tjmn-open]');
  var sheet=drawer.querySelector('.tjmn-sheet');
  var searchToggle=root.querySelector('[data-tjmn-search-toggle]');
  var searchInput=root.querySelector('#tjmn-search-input');
  var lastFocus=null;
  function mobile(){return window.matchMedia('(max-width:749px)').matches}
  function compact(){
    if(!mobile())return;
    var value=compactEnabled&&window.scrollY>compactThreshold;
    if(root.classList.contains('is-compact')!==value){
      root.classList.toggle('is-compact',value);
      if(!value)root.classList.remove('is-searching');
      if(searchToggle)searchToggle.setAttribute('aria-expanded',root.classList.contains('is-searching')?'true':'false');
    }
  }
  function activePanel(id){
    drawer.querySelectorAll('[data-tjmn-panel],[data-tjmn-subpanel]').forEach(function(p){p.hidden=true});
    var panel=drawer.querySelector('[data-tjmn-panel="'+id+'"]');
    if(panel)panel.hidden=false;
    drawer.querySelectorAll('[data-tjmn-select]').forEach(function(b){
      var selected=b.getAttribute('data-tjmn-select')===String(id);
      b.classList.toggle('is-active',selected);
      b.setAttribute('aria-pressed',selected?'true':'false');
    });
    var scroller=drawer.querySelector('.tjmn-content');
    if(scroller)scroller.scrollTop=0;
  }
  function open(){
    if(!mobile())return;
    lastFocus=document.activeElement;
    drawer.hidden=false;
    document.body.classList.add('tjmn-open');
    opener.setAttribute('aria-expanded','true');
    activePanel('0');
    sheet.focus();
  }
  function close(){
    drawer.hidden=true;
    document.body.classList.remove('tjmn-open');
    opener.setAttribute('aria-expanded','false');
    if(lastFocus&&lastFocus.focus)lastFocus.focus();
  }
  opener.addEventListener('click',open);
  drawer.addEventListener('click',function(e){
    var closer=e.target.closest('[data-tjmn-close]');
    if(closer){close();return}
    var side=e.target.closest('[data-tjmn-select]');
    if(side){activePanel(side.getAttribute('data-tjmn-select'));return}
    var sub=e.target.closest('[data-tjmn-sub]');
    if(sub){
      var code=sub.getAttribute('data-tjmn-sub');
      drawer.querySelectorAll('[data-tjmn-panel],[data-tjmn-subpanel]').forEach(function(p){p.hidden=true});
      var subpanel=drawer.querySelector('[data-tjmn-subpanel="'+code+'"]');
      if(subpanel)subpanel.hidden=false;
      var c=drawer.querySelector('.tjmn-content');if(c)c.scrollTop=0;
      return;
    }
    var back=e.target.closest('[data-tjmn-back]');
    if(back){activePanel(back.getAttribute('data-tjmn-back'));return}
  });
  drawer.addEventListener('keydown',function(e){
    if(e.key==='Escape'){e.preventDefault();close();return}
    if(e.key!=='Tab')return;
    var all=Array.prototype.filter.call(drawer.querySelectorAll('a[href],button:not([disabled]),input'),function(x){
      return x.getClientRects().length>0 && !x.closest('[hidden]');
    });
    if(!all.length)return;
    var first=all[0],last=all[all.length-1];
    if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus()}
    else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}
  });
  if(searchToggle&&searchInput)searchToggle.addEventListener('click',function(){
    root.classList.toggle('is-searching');
    var expanded=root.classList.contains('is-searching');
    searchToggle.setAttribute('aria-expanded',expanded?'true':'false');
    if(expanded)searchInput.focus();
  });
  // Reuse the theme's existing cart drawer; do not navigate to the /cart page.
  var cartLink=root.querySelector('.tjmn-cart-drawer-link');
  if(cartLink&&!cartLink.classList.contains('tjb2b-cart-link')){
    cartLink.addEventListener('click',function(event){
      if(event.button!==0||event.metaKey||event.ctrlKey||event.altKey||event.shiftKey)return;
      var cartDrawer=document.getElementById('cart-drawer');
      if(!cartDrawer)return; // Only fall back to /cart if the actual drawer is missing.
      event.preventDefault();event.stopPropagation();
      var isOpen=cartDrawer.classList.toggle('active');
      cartLink.setAttribute('aria-expanded',isOpen?'true':'false');
    });
    document.addEventListener('click',function(e){
      var cartDrawer=document.getElementById('cart-drawer');
      if(cartDrawer&&cartDrawer.classList.contains('active')&&!cartDrawer.contains(e.target)&&!e.target.closest('.tjmn-cart-drawer-link')){
        cartDrawer.classList.remove('active');
        cartLink.setAttribute('aria-expanded','false');
      }
    });
    document.addEventListener('keydown',function(e){
      var cartDrawer=document.getElementById('cart-drawer');
      if(e.key==='Escape'&&cartDrawer&&cartDrawer.classList.contains('active')){
        cartDrawer.classList.remove('active');cartLink.setAttribute('aria-expanded','false');
      }
    });
  }
  // Keep the spacer at expanded-header height to avoid content jumping.
  measureHeader();
  window.addEventListener('load',measureHeader,{once:true});
  window.addEventListener('scroll',compact,{passive:true});
  window.addEventListener('resize',function(){
    if(!mobile()&&!drawer.hidden)close();
    if(mobile()&&root.classList.contains('is-compact')){
      root.classList.remove('is-compact');
      measureHeader();
      root.classList.add('is-compact');
    } else {measureHeader();}
    compact();
  },{passive:true});
  compact();
})();